export default __webpack_public_path__ + "static/media/layer2.69fe6398.svg";